import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconReceiptCheck: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="receipt-check, ticket"><path d="M9.75 13.75H14.25M10 9.15003L11.2 10.35L14 7.55003M4.75 2.75V20.75L8.375 18.75L12 20.75L15.625 18.75L19.25 20.75V2.75H4.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconReceiptCheck;
